// Breadcrumbs Constants
export const HOME = "Home";
export const WORK_REQUESTS = "Work Requests";

// Table Header Constants
export const WORK_ORDER_NUMBER = "Work Order Number";
export const DATE = "Date";
export const CUSTOMER = "Customer";
export const LOCATION = "Location";
export const WORK_REQUEST_DESCRIPTION = "Work Request Description";
export const PRIORITY_LEVEL = "Priority Level";
export const STATUS = "Status";
export const ASSIGNEE = "Assignee";

// Breadcrumbs
export const WORKREQUESTS_BREADCRUMBS = [
  { id: "/", name: HOME },
  { id: "/workrequests", name: WORK_REQUESTS },
];

// Table Headers
export const tableHeaders = [
  WORK_ORDER_NUMBER,
  DATE,
  CUSTOMER,
  LOCATION,
  WORK_REQUEST_DESCRIPTION,
  PRIORITY_LEVEL,
  STATUS,
  ASSIGNEE,
];

export const columnWidths = ["9%", "11%", "11%", "11%", "30%", "10%", "9%", "9%"];

export const managerTableHeaders = [
  WORK_ORDER_NUMBER,
  DATE,
  CUSTOMER,
  LOCATION,
  WORK_REQUEST_DESCRIPTION,
  PRIORITY_LEVEL,
  STATUS,
  ASSIGNEE,
];

export const vendorTableHeaders = [
  WORK_ORDER_NUMBER,
  DATE,
  CUSTOMER,
  LOCATION,
  WORK_REQUEST_DESCRIPTION,
  PRIORITY_LEVEL,
  STATUS,
  ASSIGNEE,
];
